/* Revoluxe – Judge.me reviews: toon eerst 2 reviews (mobiel 1) + "See all reviews" knop.
   Raakt de Judge.me data niet aan; verbergt alleen reviews tot je op de knop klikt. */
(function () {
  var mobile = window.matchMedia('(max-width: 749px)');
  function visibleCount() { return mobile.matches ? 1 : 2; }

  // Op de aparte reviewpagina alles tonen
  if (/^\/pages\/(customer-)?reviews/.test(location.pathname)) return;

  function setup(widget) {
    // Op de reviewpagina (template met data-rvx-reviews-page) alles tonen
    if (document.querySelector('[data-rvx-reviews-page]')) return;
    if (widget.dataset.rvxCollapse) return;
    widget.dataset.rvxCollapse = '1';
    widget.classList.add('rvx-collapsed');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rvx-reviews-more';
    widget.insertAdjacentElement('afterend', btn);

    function update() {
      var list = widget.querySelector('.jdgm-review-list');
      var count = list ? list.querySelectorAll(':scope > .jm-review-item').length : 0;
      btn.textContent = 'See all reviews (' + count + ')';
      btn.hidden = !widget.classList.contains('rvx-collapsed') || count <= visibleCount();
    }

    btn.addEventListener('click', function () {
      widget.classList.remove('rvx-collapsed');
      update();
    });

    new MutationObserver(update).observe(widget, { childList: true, subtree: true });
    if (mobile.addEventListener) mobile.addEventListener('change', update);
    update();
  }

  var queued = false;
  function scan() {
    queued = false;
    document.querySelectorAll('.jdgm-widget-revamp').forEach(setup);
  }
  scan();
  new MutationObserver(function () {
    if (!queued) { queued = true; requestAnimationFrame(scan); }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
